import { render, staticRenderFns } from "./images-uploader.component.vue?vue&type=template&id=72a3d65c"
import script from "./images-uploader.component.vue?vue&type=script&lang=js"
export * from "./images-uploader.component.vue?vue&type=script&lang=js"
import style0 from "./images-uploader.component.vue?vue&type=style&index=0&id=72a3d65c&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports